const CashoutSuccessMessage = 'Thank you for your request to get cash from your home’s equity. We will reach out to you soon.';
const RefinanceSuccessMessage = 'Thank you for submitting your request to refinance your home. We will reach out to you soon.';
const PurchaseSuccessMessage = 'Thank you for submitting your request to purchase a new home. We will reach out to you soon.';
const RefinanceErrorMessage = 'Something went wrong on our end. Please call 888-369-2807 to complete the request for your refinance.';
const CashoutErrorMessage = 'Something went wrong on our end. Please call 888-369-2807 to complete your request for a Cash Out Refinance.';
const PurchaseErrorMessage = 'Something went wrong on our end. Please call 888-369-2807 to complete your request for a new home purchase.';
const AuthenticatedLeadFormsConstants = {
  CashoutSuccessMessage,
  RefinanceSuccessMessage,
  CashoutErrorMessage,
  RefinanceErrorMessage,
  PurchaseErrorMessage,
  PurchaseSuccessMessage
};
export default AuthenticatedLeadFormsConstants;
//# sourceMappingURL=index.js.map